import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ConfirmDialog from "src/Common/confirmdialog";
import { formatDate } from "src/Common/common";
import { isAdmin } from "src/Common/function";
import DropDown from "src/Components/EditDeleteDropdown/dropdown";
import ServiceTypeService from "src/Services/API/service.service";
import UserService from "src/Services/API/user.service";
import ServiceTypeAddModal from "./ServiceTypeAddModal"; 

const Active = () => {
  const currentUser = UserService.getCurrentUser();
  const [services, setServices] = useState([]);
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [isArchiveConfirmDialogShown, setIsArchiveConfirmDialogShown] = useState(false);
  const [indexForArchive, setIndexForArchive] = useState(null);

  useEffect(() => {
    getServices();
  }, []);

  const getServices = async () => {
    try {
      const response = await ServiceTypeService.getAll();
      if (response.status === 200) {
        const data = Array.isArray(response.data) ? response.data : [];
        const activeServices = data.filter((service) => service?.isActive !== false && service?.isArchived !== true);
        setServices(activeServices);
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log("Service type load error: ", error);
      toast(error?.response?.data?.message || "Failed to load services");
    }
  };

  const openAddModal = () => {
    setIsAdd(true);
    setIsEdit(false);
    setEditingService(null);
  };

  const openEditModal = (index) => {
    setIsEdit(true);
    setIsAdd(false);
    setEditingService(services[index]);
  };

  const closeModal = () => {
    setIsAdd(false);
    setIsEdit(false);
    setEditingService(null);
  };

  const handleSave = async (serviceType) => {
    const isUpdating = Boolean(editingService);
    const payload = isUpdating
      ? { ...editingService, serviceType }
      : { serviceType, company: currentUser.company };
    console.log("🚀 ~ handleSave ~ payload:", payload)

    try {
      const response = isUpdating
        ? await ServiceTypeService.update(payload)
        : await ServiceTypeService.save(payload);
      if (response.status === 200 || response.status === 201) {
        toast(isUpdating ? "Service updated successfully" : "Service added successfully");
        getServices();
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log("Service type save error: ", error);
      toast(error?.response?.data?.message || "Failed to save service");
    } finally {
      closeModal();
    }
  };

  const requestArchive = (index) => {
    setIndexForArchive(index);
    setIsArchiveConfirmDialogShown(true);
  };

  const archiveService = async () => {
    const target = services[indexForArchive];
    if (!target?.id) {
      setIsArchiveConfirmDialogShown(false);
      return;
    }
    try {
      const response = await ServiceTypeService.archive(target.id);
      if (response.status === 200 || response.status === 201) {
        toast("Service archived successfully");
        getServices();
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log("Service type archive error: ", error);
      toast(error?.response?.data?.message || "Failed to archive service");
    } finally {
      setIsArchiveConfirmDialogShown(false);
      setIndexForArchive(null);
    }
  };

  return (
    <div>
      {isAdd && <ServiceTypeAddModal onSave={handleSave} onCancel={closeModal} serviceType={null} />}
      {isEdit && <ServiceTypeAddModal onSave={handleSave} onCancel={closeModal} serviceType={editingService} />}

      {isArchiveConfirmDialogShown && (
        <ConfirmDialog
          title="ARCHIVE SERVICE"
          description="Are you sure you want to archive this service?"
          shown={isArchiveConfirmDialogShown}
          onConfirmClicked={archiveService}
          onCancelClicked={() => setIsArchiveConfirmDialogShown(false)}
        />
      )}

      <div className="flex items-center justify-end h-[62px] border-b-[1px] border-borderColor">
        {isAdmin() && (
          <div onClick={openAddModal} className="w-[120px] h-[30px] flex items-center justify-center cursor-pointer">
            <span className="text-[12px] font-[600] font-OpenSansRegular text-subTitleColor">+ Add Service Type</span>
          </div>
        )}
      </div>

      <table className="w-full">
        <thead>
          <tr className=" border-b-[1px] border-borderColor">
            <th className="border-r-[1px] border-borderColor">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                <span>Name</span>
              </div>
            </th>
            <th className="w-[150px]">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                Date Added
              </div>
            </th>
            <th className="w-[30px]"></th>
          </tr>
        </thead>
        <tbody>
          {services.map((service, i) => (
            <tr key={service.id || service.name || i} className="border-b-[1px] border-borderColor h-[40px]">
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                  {service.serviceType}
                </div>
              </td>

              <td>
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                  {service.createdAt ? formatDate(service.createdAt) : "-"}
                </div>
              </td>
              <td>
                {isAdmin() && (
                  <DropDown index={i} onDeleteClicked={requestArchive} onEditClicked={openEditModal} />
                )}
              </td>
            </tr>
          ))}
          {services.length === 0 && (
            <tr>
              <td colSpan={3} className="px-4 py-3 text-[12px] font-OpenSansRegular text-subTitleColor">
                No services yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Active;
